<template>
	<core-layout-content full>
		<core-layout-headline-and-actions>
			<template slot="headline">
				{{ $t("file_system") }}
				<core-pagination-info
					:itemsPerPage="itemsPerPage"
					:numberOfItems="listing.numberOfItems"
					:currentPage="computedPage"
				/>
			</template>

			<!--
			<template slot="actions">
				<j-button :to="{ name: 'FileSystemCreate' }">
					<crm-icon name="add" size="small" color="c5" />
					{{ $t("create") }}
				</j-button>
			</template>
			-->
		</core-layout-headline-and-actions>

		<!-- Data Container -->
		<j-card class="bg5">
			<j-data-table
				:header="header"
				:list="listing.list"
				:sortable="false"
				:isLoading="isLoading"
				@sort="onSort($event)"
			>
				<template slot="list" slot-scope="{ item }">
					<td v-for="(column, i) in header" :key="i">
						<template>
							<!-- Name -->
							<template v-if="column.field === 'bucketName'">
								<router-link
									:to="{
										name: `FileSystemDetail`,
										params: { id: item.bucketName }
									}"
								>{{ item.bucketName ? item.bucketName : "---" }}</router-link>
							</template>

							<!-- Others -->
							<template v-else>{{ item[column.field] }}</template>
						</template>
					</td>
				</template>
				<template slot="empty">{{ $t("errors.no_data") }}</template>
			</j-data-table>
		</j-card>

		<!-- Default file system -->
		<!--
			<j-button
			class="mt4"
			type="tertiary"
			:to="{
				name: `FileSystemDetail`,
				params: { id: 'default' }
			}"
		>{{ $t("default_file_system") }}</j-button>
		-->

		<!-- Pagination -->
		<div class="flex xs-12 p4 xs-center mb15">
			<j-pagination
				:amount="listing.numberOfItems ? listing.numberOfItems : 0"
				:perPage="itemsPerPage"
				:activePage="computedPage"
				@click="onPageChange($event)"
			/>
		</div>
	</core-layout-content>
</template>

<script>
import CrmIcon from "@/components/CrmIcon/"
import JButton from "@/components/JButton/"
import JCard from "@/components/JCard/"
import JDataTable from "@/components/JDataTable/"
import JTag from "@/components/JTag/"
import JBaseInputSearch from "@/components/JBaseInputSearch/"
import JPagination from "@/components/JPagination/"
import CorePaginationInfo from "@/modules/core/components/CorePaginationInfo"
import CoreLayoutContent from "@/modules/core/components/CoreLayoutContent"
import CoreLayoutHeadlineAndActions from "@/modules/core/components/CoreLayoutHeadlineAndActions"
import dayjs from "dayjs"
import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"
import get from "lodash.get"
import debounce from "lodash.debounce"

export default {
	components: {
		CrmIcon,
		JButton,
		JCard,
		JDataTable,
		JTag,
		JBaseInputSearch,
		JPagination,
		CorePaginationInfo,
		CoreLayoutContent,
		CoreLayoutHeadlineAndActions
	},

	data() {
		return {
			isLoading: false,

			// Actual fetched data
			listing: {
				numberOfItems: 0,
				list: []
			},

			// Search term
			searchTerm: null,

			// Pagination
			itemsPerPage: 30,

			// Header of table
			header: [
				{
					field: "bucketName",
					text: this.$t("name")
				},
				{
					field: "providerId",
					text: this.$t("provider")
				}
			]
		}
	},

	computed: {
		computedPage() {
			return this.$store.state.caseManagement.listing.page
		},

		computedWhere() {
			if (!this.searchTerm) return

			return {
				// TODO: What should we put in the search ?
			}
		}
	},

	methods: {
		onPageChange(pageIndex) {
			this.$store.commit("caseManagement/SET_PAGE", pageIndex)
			this.readAll()
			this.scrollToTop()
		},

		scrollToTop() {
			this.$scrollTo("body", 300)
		},

		async readAll() {
			const query = gql`
				query fileBuckets($where: bucketWhereInput) {
					fileBuckets(where: $where) {
						bucketName
						providerId
					}
				}
			`

			this.isLoading = true
			const res = await api({
				query,
				variables: { where: {} }
			})
			this.isLoading = false

			// Check errors
			if (res.errors)
				this.$store.dispatch("showError", [res.errors?.[0]?.message])

			this.listing.list = res?.data?.fileBuckets || []
			this.listing.numberOfItems = this.listing.list.length
		}
	},

	/*
	beforeRouteLeave(to, from, next) {
		// If in same module , do nothing, do not reset page
		if (to.meta.featureId === from.meta.featureId) {
			next()
		} else {
			// if not in same module, reset page to 1
			this.$store.commit("fileSystem/SET_PAGE", 1)
			next()
		}
	},
*/

	mounted() {
		this.readAll()
	}
}
</script>
